import { isNumberAnswerValid, numberRange } from '../useAppraisalFlow'
import useTranslation from 'next-translate/useTranslation'

export interface NumberInputProps {
  value: string
  unit?: string | null
  placeholder?: string | null
  /** Accepted range; without one the gold weight bounds apply. */
  range?: { min?: number | null; max?: number | null }
  onChange: (value: string) => void
}

export default function NumberInput({
  value,
  unit,
  placeholder,
  range,
  onChange,
}: NumberInputProps) {
  const { t } = useTranslation('wertCheck')
  const showError = value !== '' && !isNumberAnswerValid(value, range)
  const isWeight = range?.min == null && range?.max == null

  return (
    <div className="flex flex-col gap-1">
      <div className="input-border flex items-center rounded-xl bg-static-white px-6 py-3">
        <input
          className="w-full text-l font-semibold text-primary outline-none placeholder:font-normal placeholder:text-secondary"
          type="text"
          inputMode="decimal"
          placeholder={placeholder ?? undefined}
          value={value}
          onChange={(event) =>
            onChange(event.target.value.replace(/[^\d.,]/g, ''))
          }
        />
        {unit && <span className="text-l text-secondary ml-2">{unit}</span>}
      </div>

      {showError && (
        <p className="text-s text-center">
          {t(
            isWeight ? 'weight_invalid' : 'number_invalid',
            numberRange(range),
          )}
        </p>
      )}
    </div>
  )
}
